// Extract a YouTube video ID from any common YouTube URL or raw input.
// Always returns an 11-char ID, or "" if no valid ID is found.
export function extractYouTubeId(input) {
  if (!input) return "";
  const s = String(input).trim();
  if (!s) return "";

  // Already a clean 11-char ID
  if (/^[A-Za-z0-9_-]{11}$/.test(s)) return s;

  // Try to match common URL patterns
  const patterns = [
    /[?&]v=([A-Za-z0-9_-]{11})/,                 // youtube.com/watch?v=ID
    /youtu\.be\/([A-Za-z0-9_-]{11})/,             // youtu.be/ID
    /youtube\.com\/embed\/([A-Za-z0-9_-]{11})/,   // youtube.com/embed/ID
    /youtube\.com\/shorts\/([A-Za-z0-9_-]{11})/,  // youtube.com/shorts/ID
    /youtube\.com\/live\/([A-Za-z0-9_-]{11})/,    // youtube.com/live/ID
    /youtube-nocookie\.com\/embed\/([A-Za-z0-9_-]{11})/,
  ];
  for (const re of patterns) {
    const m = s.match(re);
    if (m) return m[1];
  }

  // Fallback: first 11-char alphanumeric chunk in the string
  const m = s.match(/([A-Za-z0-9_-]{11})/);
  return m ? m[1] : "";
}
